module.exports = __webpack_public_path__ + "static/media/Sir_Winston_Churchill.38d3189d.jpg";